import { render, staticRenderFns } from "./SupplierManufacturingEnvironment.vue?vue&type=template&id=28185502&scoped=true"
import script from "./SupplierManufacturingEnvironment.vue?vue&type=script&lang=js"
export * from "./SupplierManufacturingEnvironment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28185502",
  null
  
)

export default component.exports